import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(code: string) {
    return wrapEndpoint(() =>
      client.GET('/screening-campaign/{code}', {
        params: {
          path: {
            code,
          },
        },
      }),
    )
  },

  async list(dto?: ApiSchemas['ListScreeningCampaignDto']) {
    return wrapEndpoint(() =>
      client.GET('/screening-campaign', {
        params: {
          query: dto,
        },
      }),
    )
  },

  async create(dto: ApiSchemas['CreateScreeningCampaignDto']) {
    return wrapEndpoint(() =>
      client.POST('/screening-campaign', {
        body: dto,
      }),
    )
  },

  async update(code: string, dto: ApiSchemas['UpdateScreeningCampaignDto']) {
    return wrapEndpoint(() =>
      client.PUT('/screening-campaign/{code}', {
        params: {
          path: {
            code,
          },
        },
        body: dto,
      }),
    )
  },

  async delete(code: string) {
    return wrapEndpoint(() =>
      client.DELETE('/screening-campaign/{code}', {
        params: {
          path: {
            code,
          },
        },
      }),
    )
  },
}
